export default __webpack_public_path__ + "static/media/shopbag.f9ef983d.svg";